import React, { memo } from 'react';
import { Script } from 'gatsby';

const EXCLUDED_PATHS = new Set([
  '/development-ai-intelligence-landing-page/',
  '/upkeep-ai/',
  '/product/edge/',
]);

const CHILI_PIPER_CONFIG = {
  title: 'Thanks! What time works best for a quick call?',
  formId: 'demo-form',
};

const ROUTER_ID_MAP = {
  '/product/edge/': 'demo-request-edge-router',
  default: 'demo-request-router-l5ae3u',
};

const generateChiliPiperScript = routerId => `
  ChiliPiper.scheduling("onupkeep", "${routerId}", {
     trigger: 'ThirdPartyForm',
     formId: "${CHILI_PIPER_CONFIG.formId}",
  });
`;

const ChiliPiperScript = memo(({ routerId }) => (
  <Script strategy="idle">{generateChiliPiperScript(routerId)}</Script>
));

const ChiliPiper = ({ pathname }) => {
  if (!pathname || EXCLUDED_PATHS.has(pathname)) return null;

  const routerId = ROUTER_ID_MAP[pathname] || ROUTER_ID_MAP.default;

  return (
    <>
      <Script
        id="chilipiper-concierge"
        src="https://onupkeep.chilipiper.com/concierge-js/cjs/concierge.js"
        crossOrigin="anonymous"
        type="text/javascript"
      />

      <ChiliPiperScript routerId={routerId} />
    </>
  );
};

export default ChiliPiper;
